import { BaseScene } from './BaseScene';
import { DiceBoard } from './components/DiceBoard';

export class RollDiceScene extends BaseScene {
  // @ts-ignore
  private diceBoard: DiceBoard;
  // @ts-ignore
  private drawResult;
  scene: any;

  constructor() {
    super('RollDiceScene');
  }

  preload() {
    const config = window._po_gm.config;
    this.drawResult = config?.drawResult ? config?.drawResult : [];
  }

  createBody() {
    this.addDiceBoard();
  }

  addDiceBoard() {
    this.diceBoard = new DiceBoard(this, this.screenWidth, this.screenHeight, this.drawResult);
  }

  cleanUpListeners() {
    // this.diceBoard.cleanUpListeners();
  }

  pauseTimer() {
    this.diceBoard.pauseTimer();
  }

  resumeTimer() {
    this.diceBoard.resumeTimer();
  }
}
